var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"size":"100"}},[(_vm.company.base64Logo)?_c('v-img',{attrs:{"alt":"Logo","src":`data:image/png;base64,${_vm.company.base64Logo}`},on:{"click":function($event){return _vm.$router.push({ name: 'Summary' })}}}):_c('v-img',{attrs:{"height":_vm.height,"src":require("../assets/logo.png"),"contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }